<template>
  <div class="main-page legalaid">
    <Menus title="法律援助"
           :home="true" />
    <div class="container-flex">
      <div class="content-step">
        <Step :steplist="steplist"
              :type="type" />
        <Collect />
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import Step from '@/components/FayuanStep'
import Collect from '@/components/DataCollect/Collect'
export default {
  components: {
    Menus,
    Step,
    Collect
  },
  data () {
    return {
      steplist: ['援助预申请', '填写申请信息', '上传相关文件', '申请成功'],

      type: 1
    }
  },
  computed: {
    userinfo () {
      return this.$store.state.user.wechatUinfo
    }

  },
  mounted () {
    const step = this.$route.query.step
    if (!this.userinfo.userid) {
      this.$router.goBack()
      return
    }
    if (step) {
      this.type = parseInt(step)
    }
  }
}
</script>
<style lang="stylus" >
.legalaid
  textarea
    width 100%
    border-radius 0.08rem
    padding 0.2rem
    box-sizing border-box
    border 0
    background rgba(255, 255, 255, 0.2)
    border 0
  .content-step
    padding 0.4rem 0 0.5rem 0
  .button
    display block
    width 2.78rem
    text-align center
    height 0.9rem
    line-height 0.9rem
    font-size 0.34rem
    border 0
    margin 0.8rem auto 0.7rem auto
    background-color #fc9d0b !important
    color #fff
    border-radius 0.1rem
    &.allmater
      width 2.9rem
      background-color #214dbf !important
    .userinfo
      border-radius 0.3rem
      border solid 1px rgba(255, 255, 255, 0.2)
</style>
